<template>
  <div class="PlayBack light-bg">
    <div class="control">
      <CarList />
      <el-tooltip content="复制当前播放进度链接">
        <img :src="shareIcon" class="item" @click="onShareClick" />
      </el-tooltip>
    </div>
    <NewPlayList />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import NewPlayList from '@/components/PlayList/index.vue';
import CarList from '@/views/Home/component/CarList/index.vue';
import { getQueryVariable } from '@/utils/utils';
import copy from 'copy-to-clipboard';
import { ElMessage } from 'element-plus';
import shareIcon from '@/assets/images/share.png';
import { useFrameDataStore } from "@/store/frameDataStore";
export default defineComponent({
  components: {
    CarList,
    NewPlayList: NewPlayList,
  },
  name: 'PlayBack',
  data() {
    const frameDataStore=useFrameDataStore();
    return {
      shareIcon,
      frameDataStore
    };
  },
  methods: {
    onShareClick() {
      let vehicleId = getQueryVariable('vehicleId');
      const { origin, pathname } = location;
      try {
        if (
          copy(
            `${origin}${pathname}?vehicleId=${vehicleId}&ts=${parseInt(String(this.frameDataStore.currentTime / 1000))}`,
          )
        ) {
          ElMessage.success('复制当前时间链接成功');
        }
      } catch (e) {
        ElMessage.error('复制失败');
      }
    },
  },
});
</script>
<style lang="less" scoped>
.PlayBack {
  position: relative;
  padding: 16px 10px 0;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  height: 240px;
  width: 335px;
  box-sizing: border-box;
}

.control {
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  align-items: center;
  margin-bottom: 12px;
  height: 40px;
  justify-content: space-between;

  .item {
    width: 22px;
    height: 22px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.light-bg {
  height: 240px;

  background-size: 50% 50%;
  background-image: radial-gradient(
      circle at bottom right,
      transparent 0,
      transparent 16px,
      rgba(30, 255, 247, 0.1) 16px
    ),
    radial-gradient(
      circle at top left,
      transparent 0,
      transparent 16px,
      rgba(30, 255, 247, 0.1) 16px
    ),
    radial-gradient(
      circle at top right,
      transparent 0,
      transparent 16px,
      rgba(30, 255, 247, 0.1) 16px
    ),
    radial-gradient(
      circle at bottom left,
      transparent 0,
      transparent 16px,
      rgba(30, 255, 247, 0.1) 16px
    );
  background-repeat: no-repeat;
  background-position: right bottom, left top, right top, left bottom;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -0.5px;
    width: 1px;
    height: 240px;
    opacity: 0.4;
    background-image: linear-gradient(
      180deg,
      #fdff3900 0%,
      #fdff39 54%,
      #fdff3900 100%
    );
  }
}

.dark-bg {
  height: 240px;

  background-size: 50% 50%;
  background-image: radial-gradient(
      circle at bottom right,
      transparent 0,
      transparent 16px,
      rgba(0, 75, 131, 0.2) 16px
    ),
    radial-gradient(
      circle at top left,
      transparent 0,
      transparent 16px,
      rgba(0, 75, 131, 0.2) 16px
    ),
    radial-gradient(
      circle at top right,
      transparent 0,
      transparent 16px,
      rgba(0, 75, 131, 0.2) 16px
    ),
    radial-gradient(
      circle at bottom left,
      transparent 0,
      transparent 16px,
      rgba(0, 75, 131, 0.2) 16px
    );
  background-repeat: no-repeat;
  background-position: right bottom, left top, right top, left bottom;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -0.5px;
    width: 1px;
    height: 240px;
    opacity: 0.4;
    background-image: linear-gradient(
      180deg,
      #fdff3900 0%,
      #fdff39 54%,
      #fdff3900 100%
    );
  }
}
</style>
